import { styled } from "@mui/material/styles";
import Text from "designSystem/components/text/Text";
import { HeaderCentricIcon } from "csi/page/HeaderCentricIcon";
import React, { FunctionComponent, ReactNode } from "react";
import FlexRowCenter from "designSystem/components/flex/FlexRowCenter";

export const TitleText = styled(Text)(({ theme }) => ({
	color: theme.palette.SiteHeaderText,
	marginRight: 16,
}));

export const StyledFlexRowCenter = styled(FlexRowCenter)(({ theme }) => ({
	backgroundColor: theme.palette.SiteHeaderBG,
}));

export interface HeaderProps {
	title: string;
	leftChildren: ReactNode;
	rightChildren: ReactNode;
};

const Header: FunctionComponent<HeaderProps> = (props) => {
	const { leftChildren, rightChildren, title } = props;
	const leftChildrenWithCentricIconAndTitle = [
		(
			<FlexRowCenter key="1" mr={1}>
				<HeaderCentricIcon />
			</FlexRowCenter>
		),
		(
			<TitleText
				key="2"
				text={title}
				variant="h5"
			/>
		),
		(
			<FlexRowCenter key="3">
				{leftChildren}
			</FlexRowCenter>
		),
	];
	return (
		<StyledFlexRowCenter justifyContent="space-between">
			<FlexRowCenter ml={1}>
				{leftChildrenWithCentricIconAndTitle}
			</FlexRowCenter>
			<FlexRowCenter>
				{rightChildren}
			</FlexRowCenter>
		</StyledFlexRowCenter>
	);
};

export default Header;